module.exports = __webpack_public_path__ + "assets/img/form-verification-header.0ec3d56e.png";